import * as React from 'react';
import { IonPage, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { AppHeader_v2 as AppHeader, Container_v2 as Container } from '@mindly/ui-components';
import { useHistory } from 'react-router';

import { ProfileSettingsWidget } from '../../widgets/ProfileSettingsWidget';
import { PublicRoutes } from '../../routes/navigation';
import { useDispatch, useSelector } from 'react-redux';
import { userSelector } from '../../redux/user/selector';
import classNames from 'classnames';
import { useAnalytics } from 'src/shared';
import { setIsActive } from 'src/redux/tabBar/reducer';
import { PromoCodeTimerFeature } from 'src/features/PromoCodeTimerFeature';
import { hasUnUsedPromoCodeSelector } from 'src/redux/promoCodes/promoCodes.selectors';

export function ProfileSettings() {
  const history = useHistory();
  const user = useSelector(userSelector);
  const { trackPredefinedEvent } = useAnalytics();
  const dispatch = useDispatch();
  const hasUnUsedPromoCode = useSelector(hasUnUsedPromoCodeSelector);

  useIonViewDidEnter(() => {
    trackPredefinedEvent('PROFILE_SCREEN_VIEWED');
  }, [trackPredefinedEvent]);

  useIonViewWillEnter(() => {
    if (!user?.id) {
      history.replace(PublicRoutes.AUTH);
      return;
    }
    dispatch(setIsActive(true));
  }, [user?.id]);

  return (
    <IonPage>
      <AppHeader
        className={classNames({
          // 61px - height of the promocode banner
          'before:content-[""] before:absolute before:bottom-0 before:left-0 before:w-full before:h-[calc(100%-61px)] before:bg-color-background-white !bg-badges-info-bg':
            hasUnUsedPromoCode,
        })}
        toolbarClassName={classNames({ '![--background:transparent]': hasUnUsedPromoCode })}
      >
        <PromoCodeTimerFeature expandWidth />
      </AppHeader>

      <Container>
        <div className={classNames('!pb-2')}>
          <ProfileSettingsWidget />
        </div>
      </Container>
    </IonPage>
  );
}
